import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '@improver/components/buttons';
import { FeedbackPanelComponent } from '@improver/components/feedback-panel';
import { MODAL_REF, ModalBodyComponent, ModalFooterComponent, ModalHeaderComponent, ModalRef } from '@improver/components/modals';
import { SessionService } from '@improver/infrastructure/auth-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-extend-session-modal',
  templateUrl: './extend-session-modal.component.html',
  imports: [ModalFooterComponent, ButtonComponent, TranslateModule, FeedbackPanelComponent, ModalHeaderComponent, ModalBodyComponent],
})
export class ExtendedSessionModalComponent {
  private readonly modalRef: ModalRef<ExtendedSessionModalComponent> = inject(MODAL_REF);
  private readonly sessionService: SessionService = inject(SessionService);
  readonly extendDisabled = toSignal(this.sessionService.expired$.pipe(map(() => true)));

  close() {
    this.sessionService.endSession();
    this.modalRef.close();
  }

  extendSession() {
    this.sessionService.extendToken();
    this.modalRef.close(true);
  }
}
